export class Entity {
	id:  number | string;
	[key: string]: any;
}